/* eslint-disable no-alert */
import React from 'react';
import classNames from 'classnames';

import { ArrRight } from '@/icons/index';

import Button from '../Button/Button';
import CellData from './CellData';

import styles from './styles.module.scss';

const BusinessTariffCardWithoutHeader = ({
  data,
  // sliderHeight = 0,
  // changeSliderHeight = () => null,
  handleConnect,
}) => {
  // const [active, setActive] = useState(false);
  // const tariffDetails = useRef();

  // const showDetails = () => {
  //   const { scrollHeight } = tariffDetails.current;
  //   if (scrollHeight > sliderHeight) {
  //     changeSliderHeight(scrollHeight);
  //   }
  //   setActive(true);
  // };

  // const hideDetails = () => {
  //   setActive(false);
  // };

  // const renderPrices = ({ title = '', price = '' }, key) => (
  //   <div className={styles['price-box']} key={key}>
  //     {/* {title && <div className={styles['price-box__title']}>{title}</div>} */}
  //     {price && (
  //       <div className={styles['price-box__content']}>
  //         <span className={styles.price}>{price}</span>
  //         <span className={styles.currency}>
  //           <span className='currency'>
  //             <Currency />
  //           </span>
  //           Month
  //         </span>
  //       </div>
  //     )}
  //   </div>
  // );
  return (
    <div
      className={classNames([styles.tariff])}
      itemScope
      itemType='https://schema.org/Offer'
    >
      {(data?.name || data.ussd) && (
        <div className={styles['tariff-head']}>
          {/* <div className={styles['tariff-head__content']}>
            {data?.name && data?.name}
            {!!data.ussd && (
              <div className={styles.numbers}>
                {data?.text_before_ussd}
                <LinkNumbers numbers={data.ussd} isTel />
                {data?.text_after_ussd}
              </div>
            )}
          </div> */}
        </div>
      )}

      <div className={styles.tariff__content}>
        {/* {calls && (
          <div className={styles['content-head']}>
            <CellData data={calls} />
          </div>
        )} */}
        <div className={styles.cellContainer}>
          {!!data.sections?.length &&
            data.sections.map((item, key) => (
              <CellData data={item} key={key} />
            ))}
        </div>

        <div className={styles.bottom}>
          <Button
            className={styles.button}
            onClick={() => handleConnect(data.id)}
          >
            {data?.button_text}
            <ArrRight width={24} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BusinessTariffCardWithoutHeader;
